
import GamingLibrary_01 from '../assets/images/game-01.jpg'
import GamingLibrary_02 from '../assets/images/game-02.jpg'
import GamingLibrary_03 from '../assets/images/game-03.jpg'



const GamingLibrary = [
    {id :'library_item_0',img:GamingLibrary_01,title:'Forntair',category: 'sandbox',date_added:'24-6-2022',download:'downloaded'},
  
    {id :'library_item_1',img:GamingLibrary_02,title:'pupG',category: 'sandbox' ,date_added:'24-6-2022',download:'downloaded'},
  
    {id :'library_item_2',img:GamingLibrary_03,title:'Dota2',category: 'sandbox' ,date_added:'21-3-2022',download:'downloaded'},
  
      
  
  ]

  export default GamingLibrary